<div class="menu-bside">
  <div class="cont" *ngIf="!routing.isHot() && !routing.isNewsletter()">
    <div
      *ngIf="!(params.type === 'event' && params.id === 'super_event')"
      class="cont"
    >
      <div class="label" *ngIf="routing.isFolio()">Scan</div>
      <button
        mat-icon-button
        (click)="iScan()"
        [class.active]="routing.isScanner()"
        [class.light]="routing.theme === 'light'"
        matTooltip="Scanner"
        matTooltipPosition="left"
        *ngIf="routing.isFolio()"
      >
        <mat-icon>compass_calibration</mat-icon>
      </button>
      <div class="space" *ngIf="routing.isFolio()"></div>
      <div class="label" *ngIf="routing.isQuery()">Edit</div>
      <button
        mat-icon-button
        (click)="iMain()"
        [class.active]="routing.isMain()"
        [class.light]="routing.theme === 'light'"
        matTooltip="Main"
        matTooltipPosition="left"
        *ngIf="routing.isQuery()"
      >
        <mat-icon svgIcon="table-edit"></mat-icon>
      </button>
      <div class="space" *ngIf="routing.isQuery()"></div>
      <div
        class="label"
        *ngIf="params.type !== 'hierarchy' && !routing.isQuery()"
      >
        News
      </div>
      <button
        mat-icon-button
        [class.active]="routing.isNewsaudit()"
        [class.light]="routing.theme === 'light'"
        (click)="iNewsaudit()"
        matTooltip="News View"
        matTooltipPosition="left"
        *ngIf="params.type !== 'hierarchy' && !routing.isQuery()"
      >
        <mat-icon>assignment</mat-icon>
      </button>
      <div
        class="space"
        *ngIf="params.type !== 'hierarchy' && !routing.isQuery()"
      ></div>
      <div class="label" *ngIf="showCharts">Charts</div>
      <button
        mat-icon-button
        (click)="iChart()"
        [class.active]="routing.isChart()"
        [class.light]="routing.theme === 'light'"
        matTooltip="Chart"
        matTooltipPosition="left"
        *ngIf="showCharts"
      >
        <mat-icon>insert_chart</mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="iBenchmark()"
        [class.active]="routing.isBenchmark()"
        [class.light]="routing.theme === 'light'"
        matTooltip="Benchmark"
        matTooltipPosition="left"
        *ngIf="routing.isFolio() && !params.portfolioId"
      >
        <mat-icon>multiline_chart</mat-icon>
      </button>

      <div class="space"></div>
    </div>
  </div>
</div>
